import OverheadConductorPanel from './OverheadConductor';

class MultiConductorPanel extends OverheadConductorPanel {
  addClassParams = { class: 'WireInfo', endpointArg: 'wire_info' };

  title = 'Multi-conductor'
}

export default MultiConductorPanel;
